import Model from './model.js';
import moment from 'moment';
import axios from 'axios';

export default class EmployeeRemoval extends Model {
    urlRoot() { return '/EmployeeRemovals'; }

    constructor() {
        super(...arguments);
        this.softDelete = false;
    }

    defaults() {
        return {
            removedAt: new Date(),
            prorateSalary: true,
            isReported: false,
            notes: ''
        };
    }

    constraints() {
        return {
            employeeId: {presence: true},
            reason: {presence: true},
            removedAt: {presence: true},
            personalEmail: {email: true}
        };
    }

    initialize() {
        this.idAttribute = 'objectId';
        return super.initialize(...arguments);
    }

    setEmployee(employee) {
        this.employee = employee;
        if (employee.get('personalEmail')) {
            this.set({
                personalEmail: employee.get('personalEmail')
            });
        }
        return this.set({
            employeeId: employee.get('objectId')
        });
    }

    getEmployee() {
        return this.employee;
    }

    getFormattedDate(property, format) {
        var date = this.get(property);
        return date ? moment(date).format(format) : '';
    }

    static getForEmployee(employee) {
        return axios.get(employee.finalUrl() + '/dismissal', {
            headers: {'Authorization': app.user.getAccessToken().id}
        }).then(result => {
            return new EmployeeRemoval(result.data);
        }).catch(() => null);
    }
}



// WEBPACK FOOTER //
// ./app/new-models/employee-removal.js